// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zappyride_incentive_web--Search-module--zipcodeTooltip--gODyELbroCUZ3G_frQle {
  font-size: 12px;
  line-height: 1.4;
  white-space: normal;
}

.zappyride_incentive_web--Search-module--requiredAsterisk--LgbVrlkPSS7fBBE2C9ww {
  color: #d62d0a;
  margin-left: 2px;
}`, "",{"version":3,"sources":["webpack://./src/components/Search/Search.module.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AACJ;;AACA;EACI,cAAA;EACA,gBAAA;AAEJ","sourcesContent":[".zipcodeTooltip {\n    font-size: 12px;\n    line-height: 1.4;\n    white-space: normal;\n}\n.requiredAsterisk {\n    color: #d62d0a;\n    margin-left: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"zipcodeTooltip": `zappyride_incentive_web--Search-module--zipcodeTooltip--gODyELbroCUZ3G_frQle`,
	"requiredAsterisk": `zappyride_incentive_web--Search-module--requiredAsterisk--LgbVrlkPSS7fBBE2C9ww`
};
export default ___CSS_LOADER_EXPORT___;
